module.exports = __webpack_public_path__ + "img/our3.c13e897c.svg";